<template>
  <div class="detail-wrap">
    <!--    <el-form ref="tenant" :rules="rules" :model="tenant" :inline-message="true" class="demo-ruleForm">-->
    <div class="d-header clearfix">
      <div class="fl">
        <i class="el-icon-info"/>
        {{ dataId ? '查看' : '新增' }}价格标签
      </div>
      <div class="fr">
        <!-- <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置
        </el-button> -->
        <el-button v-if="(slPriceLabelAdd && formData.id == null) || (slPriceLabelEdit && formData.id != null)" type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>
      </div>
    </div>
    <div>

      <!-- 工单来源 -->
      <div class="d-cont edit-mce-box">
        <div class="d-item">
          <div class="title first">
            <!-- <b>创建工单</b> -->
          </div>
          <table class="table-detail">
            <tbody>
            <tr>
              <!-- <el-form-item  prop="orderTypeName"> -->
              <th>
                <em class="f-red">*</em>
                标签名称
              </th>
              <td>
                <!-- onblur="if (!(/^([0-9-]+)$/) ){alert('您的输入有误');}" -->
                <el-input type="text" autocomplete="off" v-model="formData.lableName" oninput="value=value.replace(/[^-\d]/g,'')"  clearable/>
              </td>

              <th>是保障金额</th>
              <td>
                <el-input type="number" autocomplete="off" v-model="formData.maxAmount" clearable/>
              </td>

              <th>是否使用</th>
              <td>
                <el-radio v-model="formData.usable" :label="0">否</el-radio>
                <el-radio v-model="formData.usable" :label="1">是</el-radio>
              </td>

            </tr>
            <tr>
              <th>排序</th>
              <td>
                <el-input type="number" autocomplete="off" v-model="formData.orderSeq" clearable oninput="if(value<0)value=0"/>
              </td>
              <th>
                创建人
              </th>
              <td>{{ formData.createBy }}</td>
              <th>
                创建时间
              </th>
              <td>{{ formData.createTime }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div>
        </div>
      </div>
    </div>
    <!--    </el-form>-->
  </div>
</template>
<script>


import api from "@/api/projectApi";
import {editPageMixins} from "@/mixins/tabChang";
import { mapGetters } from "vuex";

export default {
  mixins: [editPageMixins],
  name: 'edit',
  props: {
    _dataId: [String, Number],
  },
  components: {},
  data() {
    return {
      formData: {
        lableName: null,  // 价格标签
        maxAmount: 0,  // 保障金额;为0时表示无限制
        orderSeq:null,
        usable: 1,  // 是否使用:0否1是
      },

      // rules: {
      //   orderTypeName: [
      //     {required: true, message: '请输入活动名称', trigger: 'blur'},
      //
      //   ],
      // },

      activeName: 'first',
      isEdit: false,
      dataId: '',
    };
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
    // console.log(this.tenant,"tenant的值");
    this.slPriceLabelAdd = this.permissions["slPriceLabelAdd"];
    this.slPriceLabelEdit = this.permissions["slPriceLabelEdit"];
  },
  mounted() {

    this.getData();
    console.log(this.tenant, "tenant的值");
    console.log(this._dataId, "_dataId的值");
  },
  methods: {


    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http.post(api.slPriceLable.getDataUrl, {id: this.dataId}).then(res => {
          this.formData = res.data.data
        })
      }
    },
    saveData() {
      const rules = {
        lableName: [{prop: '价格标签', required: true, type: 'string', maxlength: 20,}],
        maxAmount: [{prop: '保障金额', required: false, type: 'number', max: 99999999,}],
        usable: [{prop: '是否使用', required: true, type: 'number', max: 99,}],
      }
      this.$validate(this.formData, rules).then(() => {
        this.$baseConfirm('您确定要保存吗？').then(() => {
          this.$mask.open()

          this.$http.post(api.slPriceLable.saveOrUpdateUrl, this.formData).then(res => {
            this.$message.success('保存成功')
            this.goBackIndex()
            this.$mask.close()

          }).catch(() => {
              this.$message.error("保存失败！");
              this.$mask.close()
            });
        })
      })
    },

  },
};

</script>
<style lang="scss" scoped>
// 单选框
.radio_item {
  width: 24%;
  margin-top: 10px;
  margin-bottom: 10px !important;

  > span {
    display: inline-block;
    width: 120px;
    margin-right: 13px;
    text-align: right;
    font-weight: 400;
    color: rgba(86, 86, 86, 0.96);
    font-size: 12px;
  }
}

</style>
